import { ChainId } from 'constant';
import { computed, makeAutoObservable } from 'mobx';
import storage from 'utils/storage';
import user from './user';
import contracts from './contracts';

interface TokensPrice {
    [key: string]: {
        price: number;
    };
}

const tokenPrice = storage.get('goat_onepiece_token_price_withchain');
export class TokenInfo {
    tokenPriceWithChain: {
        [ChainId.mainnet]: TokensPrice;
        [ChainId.testnet]: TokensPrice;
    } = tokenPrice || {
        [ChainId.mainnet]: {},
        [ChainId.testnet]: {},
    };
    fetchTokenList: string[] = [];

    constructor() {
        makeAutoObservable<this>(this);
    }

    @computed get tokenPrice() {
        const ts = this.tokenPriceWithChain[user.chainId];

        return ts;
    }

    setTokensPrice(tokensPrice: TokensPrice) {
        this.tokenPriceWithChain[user.chainId] = {
            ...this.tokenPrice,
            ...tokensPrice,
        };
        storage.set('goat_onepiece_token_price_withchain', this.tokenPriceWithChain);
    }

    addFetchTokens(tokens: string[]) {
        this.fetchTokenList = [...Array.from(new Set(this.fetchTokenList.concat(tokens)))];
    }
}

export default new TokenInfo();
